import Vue from 'vue'
import Router from 'vue-router'
import Top from './views/ja/Top.vue'
import enTop from './views/en/Top.vue'
import TermsOfService from './views/ja/TermsOfService.vue'
import enTermsOfService from './views/en/TermsOfService.vue'
import PrivacyPolicy from './views/ja/PrivacyPolicy.vue'
import enPrivacyPolicy from './views/en/PrivacyPolicy.vue'
import AppText from './views/app/Text.vue'
import Faq from './views/Faq.vue'
import AboutUs from './views/ja/AboutUs.vue'
import enAboutUs from './views/en/AboutUs.vue'
import Likes from './views/like/Likes.vue'
import LikeDetail from './views/like/LikeDetail.vue'
import MyProfile from './views/like/MyProfile.vue'
import OnBoarding from './views/like/OnBoarding.vue'
import FavoriteList from './views/like/FavoriteList'
import Post from './views/like/Post.vue'
import SignIn from './views/like/SignIn.vue'
import SignOut from './views/like/SignOut.vue'
import SignInTemp from './views/like/SignInTemp.vue'
import Rooms from './views/like/Rooms.vue'
import Room from './views/like/Room.vue'
import WorldMap from './views/like/WorldMap.vue'
import Activity from './views/like/Activity.vue'
import Admin from './views/like/Admin.vue'

import goTo from 'vuetify/es5/services/goto'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0

    if (to.hash) {
      scrollTo = to.hash
    } else if (savedPosition) {
      scrollTo = savedPosition.y
    }

    return goTo(scrollTo)
  },
  routes: [
    {
      path: '/',
      name: 'Top',
      component: Top
    },
    {
      path: '/en/',
      name: 'enTop',
      component: enTop
    },
    {
      path: '/ja/tos',
      name: 'TermsOfService',
      component: TermsOfService
    },
    {
      path: '/en/tos',
      name: 'enTermsOfService',
      component: enTermsOfService
    },
    {
      path: '/ja/privacy',
      name: 'PrivacyPolicy',
      component: PrivacyPolicy
    },
    {
      path: '/en/privacy',
      name: 'enPrivacyPolicy',
      component: enPrivacyPolicy
    },
    {
      path: '/ja/aboutUs',
      name: 'AboutUs',
      component: AboutUs
    },
    {
      path: '/en/aboutUs',
      name: 'enAboutUs',
      component: enAboutUs
    },
    {
      path: '/ja/faq',
      name: 'Faq',
      component: Faq
    },
    {
      path: '/en/faq',
      name: 'enFaq',
      component: Faq
    },
    {
      path: '/likes',
      name: 'Likes',
      component: Likes,
    },
    {
      path: '/onBoarding/:page',
      name: 'OnBoarding',
      component: OnBoarding,
    },
    {
      path: '/likeDetail/:pid',
      name: 'LikeDetail',
      component: LikeDetail,
    },
    {
      path: '/profile/:uid',
      name: 'Profile',
      component: LikeDetail,
    },
    {
      path: '/profile',
      name: 'MyProfilePreview',
      component: LikeDetail,
    },
    {
      path: '/myProfile',
      name: 'MyProfile',
      component: MyProfile,
    },
    {
      path: '/favoriteList',
      name: 'FavoriteList',
      component: FavoriteList,
    },
    {
      path: '/post/:pid',
      name: 'Post',
      component: Post,
    },
    {
      path: '/signIn/:next/:param',
      name: 'SignInParam',
      component: SignIn,
    },
    {
      path: '/signIn/:next',
      name: 'SignIn',
      component: SignIn,
    },
    {
      path: '/signInTemp/',
      name: 'SignInTemp',
      component: SignInTemp,
    },
    {
      path: '/signOut',
      name: 'SignOut',
      component: SignOut,
    },
    {
      path: '/inbox',
      name: 'Inbox',
      component: Rooms,
    },
    {
      path: '/room/:rid',
      name: 'Room',
      component: Room,
    },
    {
      path: '/paikeout/:uid',
      name: 'RoomUid',
      component: Room,
    },
    {
      path: '/maps',
      name: 'WorldMap',
      component: WorldMap,
    },
    {
      path: '/activity',
      name: 'Activity',
      component: Activity,
    },
    {
      path: '/rnActivity/:uid',
      name: 'RNActivity',
      component: Activity,
    },
    {
      path: '/app/tos/:lang',
      name: 'AppTos',
      component: AppText,
    },
    {
      path: '/app/privacy/:lang',
      name: 'AppPrivacy',
      component: AppText,
    },
    {
      path: '/rbabpgbxbn',
      name: 'Admin',
      component: Admin,
    },
    {
      path: '/:dummy',
      redirect: '/',
    },
  ]
})
